export default {
  getOrderList: '/gateway/capp/mallcenter/ordercenter/queryOrderList',
  applyRefund: '/gateway/capp/mallcenter/ordercenter/applyRefund',
  confirmSign: '/gateway/capp/mallcenter/ordercenter/confirmSignfor'
}
